import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';

export const deleteSection = async (menuId: string, sectionId: string): Promise<void> => {
  const res = await fetch(`${API_URL}/menus/${menuId}/sections/${sectionId}`, {
    method: 'DELETE',
  });

  if (res.status !== Status.NO_CONTENT) {
    throw new Error('Could not delete section');
  }
};
